import React from "react";
import { Grid, Header } from "semantic-ui-react";

const Incompatible = () => {
  return (
    <Grid centered className="h-100">
      <Grid.Row>
        <Grid.Column width="6" textAlign="center" verticalAlign="middle">
          <img src="logo.png" alt="Rimini Logo" id="logo" />
          <Header as="h2" color="blue">
            Browser Not Supported
          </Header>
          <p>
            Unfortunately, Internet Explorer is not compatible with Rimini
            Portal.
          </p>
          <p>
            Please try another browser such as <b>Chrome</b>, <b>Firefox</b> or{" "}
            <b>Edge</b>.
          </p>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default Incompatible;
